import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedMember, clearSelectedMember } from "@/store/authSlice";
import { RootState } from "@/store";
import { useManagedMembersContext } from "@/context/ManagedMembersContext";
import { setNavigationSource } from "@/utils/navigationSource";
import FamilyOverview from "./FamilyOverview";

const HealthMemoriesOverview: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInMember = useSelector((state: RootState) => state.auth.member);
  const { managedMembers } = useManagedMembersContext();

  // Clear selectedMember when overview screen loads
  useEffect(() => {
    dispatch(clearSelectedMember());
    localStorage.removeItem("selectedMember");
  }, [dispatch]);

  const handleMemberAction = (memberId: string, action: string) => {
    // Find the member object from managedMembers
    const member = managedMembers.find((m) => m.id === memberId);

    // Update selectedMember in Redux (like profile picker does)
    if (member) {
      if (member.id === loggedInMember?.id) {
        dispatch(clearSelectedMember());
      } else {
        dispatch(setSelectedMember(member));
      }
    }

    if (action === "add") {
      // Set navigation source to current overview page
      setNavigationSource("overview", window.location.pathname);
      // Navigate to add health memory for this member
      navigate("/documents/health-memory/add", {
        state: { memberId, backUrl: window.location.pathname },
      });
    } else if (action === "navigate") {
      // Set navigation source to current overview page
      setNavigationSource("overview", window.location.pathname);
      // Navigate to health memories list for this member
      navigate("/documents/health-memory", {
        state: { memberId, backUrl: window.location.pathname },
      });
    }
  };

  return (
    <FamilyOverview
      type="health-memories"
      onMemberAction={handleMemberAction}
    />
  );
};

export default HealthMemoriesOverview;
